import type { AdminEnvironment } from './types-environment';

export const envAdmin: AdminEnvironment = Object.freeze(<AdminEnvironment>{
  basePath: 'https://internal.api.test.union-investment.de/web/ik/rpt/api',
  oauth: {
    clientId: '410267a4-59fa-414c-99c1-ce2459932285',
    scope: 'openid profile 410267a4-59fa-414c-99c1-ce2459932285',
    tokenEndpoint:
      'https://auth-test.user.union-investment.de/b2cunioninvestmenttest.onmicrosoft.com/B2C_1A_SIGNIN_IKONLINE/oauth2/v2.0/authorize',
    issuer:
      'https://auth-test.user.union-investment.de/b2cunioninvestmenttest.onmicrosoft.com/B2C_1A_SIGNIN_IKONLINE/v2.0/',
    redirectUri: window.location.origin + '/oauth2/callback',
  },
  logging: {
    connectionString:
      'InstrumentationKey=ff298b57-be59-42fb-890f-10e01c55790c;IngestionEndpoint=https://westeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=26cc6f57-3568-4b72-882a-e545432e39c8',
  },
});
